import * as React from "react";

export type CategoryStatProps = {
  categoryName: string;
  categoryStanding: number;
  categoryScore: number;
  categoryHistogram: number[];
};

const SCORE_STEPS = [0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5];

export const CategoryStat = ({
  categoryName,
  categoryStanding,
  categoryScore,
  categoryHistogram,
}: CategoryStatProps): JSX.Element | null => {
  if (!categoryName) {
    return null;
  }

  const counts = SCORE_STEPS.reduce<Record<number, number>>((acc, step) => {
    acc[step] = 0;
    return acc;
  }, {});

  categoryHistogram.forEach((vote) => {
    counts[vote] += 1;
  });

  const maxCount = Math.max(...Object.values(counts), 1);

  return (
    <div className="rounded-2xl border border-slate-200 bg-white/90 px-6 py-5 shadow-sm backdrop-blur-sm dark:border-slate-700 dark:bg-slate-800 dark:shadow-none">
      <div className="mb-1 flex items-baseline justify-between">
        <h4 className="text-lg font-semibold text-slate-800 dark:text-white">
          {categoryName}
        </h4>
        <span className="text-sm font-medium text-slate-500 dark:text-slate-400">
          #{categoryStanding}
        </span>
      </div>
      <div className="mb-4 text-sm text-slate-500 dark:text-slate-400">
        {categoryScore.toFixed(2)} from {categoryHistogram.length} votes
      </div>
      <div className="space-y-1.5">
        {SCORE_STEPS.map((score) => {
          const barWidth = (counts[score] / maxCount) * 100;
          return (
            <div key={score} className="flex items-center gap-2">
              <span className="w-[32px] text-right text-xs text-slate-500 dark:text-slate-400">
                {score.toFixed(1)}
              </span>
              <div className="relative h-5 flex-1 overflow-hidden rounded bg-slate-200/30 dark:bg-slate-700/30">
                {counts[score] > 0 && (
                  <div
                    className="flex h-full items-center rounded bg-gradient-to-r from-yellow-300 to-green-400"
                    style={{ width: `${barWidth}%` }}
                  >
                    <span className="pl-2 text-xs font-medium text-slate-700">
                      {counts[score]}
                    </span>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};